import { ChatType } from "@api/graphql/types-and-hooks";

/**
 * The caregiver relationship to display for a chat: the primary one when the
 * learner has it, otherwise the first.
 *
 * Returns the relationship node rather than the caregiver, because the header
 * also needs `socialRelationship` from it.
 */
export const primaryRelationship = (chat: ChatType) => {
  const edges = chat.learner?.relationshipSet?.edges ?? [];
  return edges.find((edge) => edge?.node?.isPrimary)?.node ?? edges[0]?.node ?? null;
};
